<template>
  <div class="container">
    <div class="has-text-centered pt-4 pb-6">
      <p class="title">Parabéns!</p>
      <p class="subtitle">Agora você já tem agendamento Online</p>
    </div>
    <div class="columns is-variable is-1 mb-0">
      <div class="column">
        <div class="box">
          <p class="subtitle">
            Nós sabemos que seu tempo é bem corrido então já criamos uma agenda
            e tudo que você precisa fazer para colocá-la em produção e
            configurá-la do seu jeito. Isso é bem fácil e dá pra fazer em 5
            minutos.<br />Assista o vídeo nesta página para ver como é fácil
            configurar sua agenda
          </p>
          <p>
            <a href="https://maxagenda.netlify.app/#/"
              >Clique aqui para acessar sua agenda</a
            >
          </p>
        </div>
      </div>
      <div class="column">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/zsIDytBZUgc"
          title="Como configurar sua agenda"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ThanksRegister",
  components: {},
  data() {
    return {
      office: {},
    };
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

